import React from 'react'
import { Link } from 'gatsby'

import './head.scss'

const Head = () => (
  <div className="head">
    <Link className="head__content" to="/me-connaitre/">
      <p className="head__content-title">Morgane Laroche</p>
      <p className="head__content-description">
        Psychologue Clinicienne à Montpellier
      </p>
    </Link>
    <div className="head__content-separator" />
  </div>
)

export default Head
